module.exports = __webpack_public_path__ + "static/media/brVideo7.ccf76daa.mp4";